import { trackSegmentEvent } from "./analytics"
import { setGetStartedModalOpen } from "./layout"
import { showIntercom } from "./V2/intercom"

import { CURRENT_PAGE } from "@constants/segmentEvents"

export interface SharedButtonClickProps {
  trackingEvent?: string
  trackingEventKey?: string
  trackingEventValue?: string
  scrollOffset?: number
  onClick?: () => void
}

export interface buttonClickProps extends SharedButtonClickProps {
  e: React.MouseEvent<HTMLElement>
  linkUrl?: string
}

export const handleOnClick = ({
  e,
  linkUrl,
  trackingEvent,
  trackingEventKey,
  trackingEventValue,
  scrollOffset = 0,
  onClick,
}: buttonClickProps) => {
  if (trackingEvent) {
    let event: Record<string, string> | undefined

    if (trackingEventKey === CURRENT_PAGE) {
      event = { page: globalThis.location.pathname }
    } else {
      event =
        trackingEventKey && trackingEventValue
          ? { [trackingEventKey]: trackingEventValue }
          : undefined
    }

    trackSegmentEvent(trackingEvent, event)
  }

  if (onClick) {
    onClick()
  } else if (linkUrl?.startsWith("#")) {
    e.preventDefault()

    if (linkUrl.includes("intercom")) {
      showIntercom()
    } else if (linkUrl.includes("#get-started")) {
      setGetStartedModalOpen(true)
    } else {
      const [scrollId, clickId] = linkUrl.includes("@")
        ? linkUrl.split("@")
        : [linkUrl, null]

      if (clickId) {
        document.getElementById(clickId)?.click()
      }

      if (scrollId !== "#") {
        const targetElement = document.querySelector(scrollId)
        if (targetElement) {
          const elementRect = targetElement.getBoundingClientRect()
          const absoluteElementTop = elementRect.top + globalThis.pageYOffset
          const offset = scrollOffset
          const targetScrollPosition = absoluteElementTop - offset

          globalThis.scrollTo({
            top: targetScrollPosition,
            behavior: "smooth",
          })
        }
      }
    }
  }
}
